import React from 'react';

const ScriptAdd = React.lazy(() => import('pages/Script/pages/ScriptAdd'));
const ScriptPage = React.lazy(() => import('pages/Script/pages/ScriptPage'));
const ScriptEdit = React.lazy(() => import('pages/Script/pages/ScriptEdit'));
const DetailPage = React.lazy(() => import('pages/Script/pages/ScriptDetail'));

const SciptRoute = [
  {
    path: '/script',
    exact: true,
    name: 'Danh sách kịch bản',
    component: ScriptPage,
  },
  {
    path: '/script/add',
    exact: true,
    name: 'Thêm mới kịch bản',
    component: ScriptAdd,
  },
  {
    path: '/script/edit/:id',
    exact: true,
    name: 'Chỉnh sửa kịch bản',
    component: ScriptEdit,
  },
  {
    path: '/script/detail/:id',
    exact: true,
    name: 'Chi tiết kịch bản',
    // function: 'CRM_CUSTOMEROFTASK_VIEW',
    component: DetailPage,
  },
];

export default SciptRoute;
